import React from "react";
import PreventiveMaintinanceTable from "./preventive-maintainance-table/PreventiveMaintainanceTable";

const PreventiveMaintainance = () => {
  return (
    <>
      {/* <div data-aos="fade-up" data-aos-duration="500"> */}
      <PreventiveMaintinanceTable />
      {/* </div> */}
    </>
  );
};

export default PreventiveMaintainance;
